// extracted by mini-css-extract-plugin
export var divider = "_32-0";
export var dividerText = "_32-1";